export default __webpack_public_path__ + "static/media/dragAndDrop.9f82ab41.png";